import { Link, Navigate, Route, Routes } from "react-router-dom";
import { RequireAdmin } from "@/components/auth/RequireAdmin";
import { AppShell } from "@/components/layout/AppShell";
import LoginPage from "@/src/pages/login";
import PosPage from "@/src/pages/pos";
import DashboardPage from "@/src/pages/dashboard";
import ProductCategoriesPage from "@/src/pages/products/categories";
import ProductDetailPage from "@/src/pages/products/product-detail";
import ProductsPage from "@/src/pages/products";
import SuppliersPage from "@/src/pages/suppliers";
import SupplierDetailPage from "@/src/pages/suppliers/supplier-detail";
import CustomersPage from "@/src/pages/customers";
import CustomerDetailPage from "@/src/pages/customers/customer-detail";
import MarketingPage from "@/src/pages/marketing";
import MarketingWhatsappPage from "@/src/pages/marketing/whatsapp";
import MarketingVouchersPage from "@/src/pages/marketing/vouchers";
import MarketingOffersPage from "@/src/pages/marketing/offers";
import MarketingCataloguePage from "@/src/pages/marketing/catalogue";
import ReportsPage from "@/src/pages/reports";
import ReportsSalesPage from "@/src/pages/reports/sales";
import ReportsGstr1Page from "@/src/pages/reports/gstr1";
import ReportsGstr3bPage from "@/src/pages/reports/gstr3b";
import ReportsStockPage from "@/src/pages/reports/stock";
import ReportsProfitPage from "@/src/pages/reports/profit";
import SaleDetailPage from "@/src/pages/sales/sale-detail";
import PurchaseOrdersPage from "@/src/pages/purchase/orders";
import PurchaseGrnPage from "@/src/pages/purchase/grn";
import PurchaseOrderCreatePage from "@/src/pages/purchase/orders/create";
import PurchaseOrderDetailPage from "@/src/pages/purchase/orders/order-detail";
import PurchaseGrnDetailPage from "@/src/pages/purchase/grn/grn-detail";
import SettingsPage from "@/src/pages/settings";
import AdminUsersPage from "@/src/pages/admin/users";
import AdminUserDetailPage from "@/src/pages/admin/user-detail";
import AdminRolesPage from "@/src/pages/admin/roles";
import AdminAuditPage from "@/src/pages/admin/audit";
import AdminShiftsPage from "@/src/pages/admin/shifts";
import AdminBranchesPage from "@/src/pages/admin/branches";
import ProfilePage from "@/src/pages/profile";
import ProductAdminCompaniesPage from "@/src/pages/product-admin/companies";
import ProductAdminCompanyDetailPage from "@/src/pages/product-admin/companies/company-detail";
import ProductAdminUsersPage from "@/src/pages/product-admin/users";
import ProductAdminDashboardPage from "@/src/pages/product-admin/dashboard";
import ProductAdminAttendancePage from "@/src/pages/product-admin/attendance";
import ProductAdminLeadsPage from "@/src/pages/product-admin/leads";
import RootHome from "@/src/pages/root-home";

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-muted-foreground">Page not found.</p>
      <div className="flex flex-wrap items-center justify-center gap-3 text-sm">
        <Link to="/" className="text-primary underline">
          Home
        </Link>
        <Link to="/dashboard" className="text-primary underline">
          Dashboard
        </Link>
      </div>
    </div>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pos" element={<PosPage />} />
      <Route path="/" element={<RootHome />} />
      <Route element={<AppShell />}>
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="products/categories" element={<ProductCategoriesPage />} />
        <Route path="products/:id" element={<ProductDetailPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="suppliers/:id" element={<SupplierDetailPage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="customers/:id" element={<CustomerDetailPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="marketing/whatsapp" element={<MarketingWhatsappPage />} />
        <Route path="marketing/vouchers" element={<MarketingVouchersPage />} />
        <Route path="marketing/offers" element={<MarketingOffersPage />} />
        <Route path="marketing/catalogue" element={<MarketingCataloguePage />} />
        <Route path="marketing" element={<MarketingPage />} />
        <Route path="reports/sales" element={<ReportsSalesPage />} />
        <Route path="reports/gstr1" element={<ReportsGstr1Page />} />
        <Route path="reports/gstr3b" element={<ReportsGstr3bPage />} />
        <Route path="reports/stock" element={<ReportsStockPage />} />
        <Route path="reports/profit" element={<ReportsProfitPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="sales/:id" element={<SaleDetailPage />} />
        <Route path="purchase/orders/create" element={<PurchaseOrderCreatePage />} />
        <Route path="purchase/orders/:id" element={<PurchaseOrderDetailPage />} />
        <Route path="purchase/orders" element={<PurchaseOrdersPage />} />
        <Route path="purchase/grn/:id" element={<PurchaseGrnDetailPage />} />
        <Route path="purchase/grn" element={<PurchaseGrnPage />} />
        <Route path="purchase" element={<Navigate to="/purchase/orders" replace />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="product-admin/dashboard" element={<ProductAdminDashboardPage />} />
        <Route path="product-admin/companies" element={<ProductAdminCompaniesPage />} />
        <Route path="product-admin/companies/:id" element={<ProductAdminCompanyDetailPage />} />
        <Route path="product-admin/attendance" element={<ProductAdminAttendancePage />} />
        <Route path="product-admin/leads" element={<ProductAdminLeadsPage />} />
        <Route path="product-admin/users" element={<ProductAdminUsersPage />} />
        <Route
          path="admin/users/:id"
          element={
            <RequireAdmin>
              <AdminUserDetailPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/users"
          element={
            <RequireAdmin>
              <AdminUsersPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/roles"
          element={
            <RequireAdmin>
              <AdminRolesPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/audit"
          element={
            <RequireAdmin>
              <AdminAuditPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/shifts"
          element={
            <RequireAdmin>
              <AdminShiftsPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/branches"
          element={
            <RequireAdmin>
              <AdminBranchesPage />
            </RequireAdmin>
          }
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
